module.exports = __webpack_public_path__ + "./images/0ff0b5353c57d8af8a4deaea62bcd98a.webp";